import { render, staticRenderFns } from "./legend2.vue?vue&type=template&id=971a6994&scoped=true"
import script from "./legend2.vue?vue&type=script&lang=js"
export * from "./legend2.vue?vue&type=script&lang=js"
import style0 from "./legend2.vue?vue&type=style&index=0&id=971a6994&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971a6994",
  null
  
)

export default component.exports